import script from "./EditEventOverlayPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditEventOverlayPanel.vue?vue&type=script&lang=ts&setup=true"

import "./EditEventOverlayPanel.vue?vue&type=style&index=0&id=407a7992&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-407a7992"]])

export default __exports__